import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import { Formik } from "formik";
import React, { useEffect } from "react";
import { fabricanteFindAll } from "../../../services/FabricanteService";
import {
    siteDelete,
    siteFindAll,
    siteInsert,
    siteUpdate,
} from "../../../services/SiteService";
import { ButtonCancel, ButtonDelete, ButtonSave } from "../../botoes/operacao";
// import DialogTitle from "@material-ui/core/DialogTitle";
// import Divider from "@material-ui/core/Divider";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import {
    KeyboardDateTimePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { format } from "date-fns";

import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { Loading } from "../../Loading";
import { ShowMessageBox } from "../../ShowMessageBox";

import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
// import { Slider } from "@material-ui/core";

//import { usuarioFindByNotSitId } from '../../../services/UsuarioService';

//import { PickList } from 'primereact/picklist';

const useStyles = makeStyles((theme) => ({
    box: {
        display: "flex",
        "flex-direction": "row",
        "justify-content": "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        backgroundColor: "transparent",
    },
    boxPrancheta: {
        height: "650px",
        width: "1100px",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
    },
    boxDataGrid: {
        "& .header_grid": {
            backgroundColor: "black",
            color: "white",
        },
        width: "100%",
        height: "500px",

        "& .MuiDataGrid-row.Mui-even:not(:hover)": {
            backgroundColor: "#ccffff",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-odd:not(:hover)": {
            backgroundColor: "#ffffcc",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-selected:not(:hover)": {
            backgroundColor: "#999999",
            color: "white",
        },
        "& .MuiDataGrid-row.Mui-selected:hover": {
            backgroundColor: "#999999",
            color: "white",
        },
        "& .MuiDataGrid-row:hover": {
            backgroundColor: "#999999",
            color: "white",
        },
    },
    side_content: {
        display: "grid",
        overflow: "auto",
    },
    nome: {
        marginTop: "1.2rem",
        width: "400px",
    },
    header_grid: {
        backgroundColor: "black",
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    fab: {
        display: "inline",
        position: "absolute",
        bottom: "0px",
        right: "0",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

//let inserir = false;
let severity = "success";
let msg = "";

export default function Dialogo(params) {
    const [openLoadingDialog, setOpenLoadingDialog] = React.useState(false);
    const [openSnackBarDialog, setOpenSnackBarDialog] = React.useState(false);
    const [listFabricante, setListFabricante] = React.useState([]);

    const classes = useStyles();
    //const [listSite, setListSite] = React.useState([]);

    useEffect(async () => {
        setOpenLoadingDialog(true);
        const respFabricante = await fabricanteFindAll();
        setListFabricante(respFabricante.data);
        setOpenLoadingDialog(false);
    }, []);

    const deleteRecord = async () => {
        setOpenSnackBarDialog(false);
        setOpenLoadingDialog(true);
        try {
            await siteDelete({ sit_id: params.selection.sit_id });
            const resp = await siteFindAll();
            params.setListSite(resp.data);
            msg = "Site excluido com sucesso";
            severity = "success";
            params.setOpenDialog(false);
            setOpenSnackBarDialog(true);
            setOpenLoadingDialog(false);
            params.inserir = true;
        } catch (error) {
            console.log(error);
            msg = "Erro ao excluir o site. Está em uso pelo sistema";
            severity = "error";
            setOpenSnackBarDialog(true);
            setOpenLoadingDialog(false);
        }
    };

    const horarios = [
        {
            id: -12,
        },
        {
            id: -11,
        },
        {
            id: -10,
        },
        {
            id: -9,
        },
        {
            id: -8,
        },
        {
            id: -7,
        },
        {
            id: -6,
        },
        {
            id: -5,
        },
        {
            id: -4,
        },
        {
            id: -3,
        },
        {
            id: -2,
        },
        {
            id: -1,
        },
        {
            id: 0,
        },
        {
            id: 1,
        },
        {
            id: 2,
        },
        {
            id: 3,
        },
        {
            id: 4,
        },
        {
            id: 5,
        },
        {
            id: 6,
        },
        {
            id: 7,
        },
        {
            id: 8,
        },
        {
            id: 9,
        },
        {
            id: 10,
        },
        {
            id: 11,
        },
        {
            id: 12,
        },
    ];

    return (
        <Dialog open={params.openDialog} aria-labelledby="form-dialog-title">
            <div
                id="form-dialog-title"
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    paddingRight: "2rem",
                    paddingLeft: "2rem",
                    alignItems: "center",
                    background: "lightblue",
                    height: "4rem",
                    marginBottom: "1.2rem",
                }}
            >
                <span style={{ fontSize: "1.2rem" }}>Manutenção de Sites</span>
                <ButtonCancel
                    variant="contained"
                    color="primary"
                    type="button"
                    style={{
                        padding: "3px",
                        color: "white",
                        fontWeight: "bold",
                    }}
                    onClick={params.closeDialog}
                >
                    <CloseIcon />
                </ButtonCancel>
            </div>
            <DialogContent>
                <Loading open={openLoadingDialog} />
                <ShowMessageBox
                    open={openSnackBarDialog}
                    setOpen={setOpenSnackBarDialog}
                    severity={severity}
                    msg={msg}
                />

                <Formik
                    initialValues={{
                        sitId: params.selection.sit_id,
                        sitNome: params.selection.sit_nome,
                        sitContainerDelimitador: params.selection.sit_container_delimitador,
                        sitCaracter: params.selection.sit_caracter,
                        fabNome: params.selection.fab_nome,
                        sitOrigem: params.selection.sit_origem,
                        sitMonitor: params.selection.sit_monitor,
                        sitPrimAnalise: params.selection.sit_prim_analise,
                        sitDtUltimaOperacao: params.selection.sit_dt_ultima_operacao,
                        sitDtCadastro: params.selection.sit_dt_cadastro,
                        sitAjusteHorario: params.selection.sit_ajuste_horario,
                    }}
                    validate={(values) => {
                        const errors = {};
                        if (!values.sitNome) {
                            errors.sitNome = "Obrigatório";
                        }
                        if (!values.sitCaracter) {
                            errors.sitCaracter = "Obrigatório";
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        setSubmitting(true);
                        setOpenSnackBarDialog(false);
                        setOpenLoadingDialog(true);
                        if (params.inserir) {
                            try {
                                await siteInsert({
                                    sit_id: values.sitId,
                                    sit_nome: values.sitNome,
                                    sit_caracter: values.sitCaracter,
                                    fab_nome: values.fabNome,
                                    sit_origem: values.sitOrigem,
                                    sit_monitor: values.sitMonitor,
                                    sit_prim_analise: values.sitPrimAnalise,
                                    sit_dt_ultima_operacao: values.sitDtUltimaOperacao,
                                    sit_dt_cadastro: values.sitDtCadastro,
                                    sit_ajuste_horario: values.sitAjusteHorario,
                                    sit_container_delimitador: values.sitContainerDelimitador
                                });

                                const respSite = await siteFindAll();
                                params.setListSite(respSite.data);
                                msg = "Site incluido com sucesso";
                                severity = "success";
                                setOpenSnackBarDialog(true);
                                params.setOpenDialog(false);
                                setOpenLoadingDialog(false);
                                setSubmitting(false);
                            } catch (err) {
                                msg = "Erro ao inserir Site";
                                severity = "error";
                                setOpenLoadingDialog(false);
                                setOpenSnackBarDialog(true);
                                setSubmitting(false);
                            }
                        } else {
                            setSubmitting(true);
                            setOpenLoadingDialog(true);
                            try {
                                await siteUpdate({
                                    sit_id: values.sitId,
                                    sit_nome: values.sitNome,
                                    sit_caracter: values.sitCaracter,
                                    fab_nome: values.fabNome,
                                    sit_origem: values.sitOrigem,
                                    sit_monitor: values.sitMonitor,
                                    sit_prim_analise: values.sitPrimAnalise,
                                    sit_dt_ultima_operacao: format(
                                        new Date(),
                                        "yyyy-MM-dd'T'HH:mm:ss"
                                    ),
                                    sit_ajuste_horario: values.sitAjusteHorario,
                                    sit_container_delimitador: values.sitContainerDelimitador,
                                });

                                const respSite = await siteFindAll();
                                params.setListSite(respSite.data);
                                msg = "Site atualizado com sucesso";
                                severity = "success";
                                setOpenSnackBarDialog(true);
                                params.setOpenDialog(false);
                                setOpenLoadingDialog(false);
                                setSubmitting(false);
                            } catch (error) {
                                msg = "Erro ao atualizar site";
                                severity = "error";
                                setOpenLoadingDialog(false);
                                setOpenSnackBarDialog(true);
                                setSubmitting(false);
                            }
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <div className={classes.input_data}>
                                <TextField
                                    value={values.sitId}
                                    id="sitId"
                                    name="sitId"
                                    type="text"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Id do Site"
                                    className={classes.nome}
                                    helperText={errors.sitId}
                                />

                                <TextField
                                    value={values.sitNome}
                                    name="sitNome"
                                    id="sitNome"
                                    type="text"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Nome do Site"
                                    className={classes.nome}
                                    helperText={errors.sitNome}
                                />
                                <TextField
                                    value={values.sitContainerDelimitador}
                                    name="sitContainerDelimitador"
                                    id="sitContainerDelimitador"
                                    type="text"
                                    inputProps={{ maxLength: 1 }}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Delimitador"
                                    className={classes.nome}
                                    helperText={errors.sitContainerDelimitador}
                                />


                                <FormControl
                                    className={classes.formControl}
                                    style={{ marginTop: "1.2rem" }}
                                >
                                    <InputLabel id="label-horario">Horario</InputLabel>

                                    <Select
                                        labelId="label-horario"
                                        id="sitAjusteHorario"
                                        name="sitAjusteHorario"
                                        value={values.sitAjusteHorario}
                                        onChange={handleChange}
                                    >
                                        {horarios.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.id}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl
                                    className={classes.formControl}
                                    style={{ marginTop: "1.2rem" }}
                                >
                                    <InputLabel id="label-caracter">Caracter</InputLabel>

                                    <Select
                                        labelId="label-caracter"
                                        id="sitCaracter"
                                        name="sitCaracter"
                                        value={values.sitCaracter}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="UTF-8">UTF-8</MenuItem>
                                        <MenuItem value="UTF-16">UTF-16</MenuItem>
                                    </Select>
                                </FormControl>

                                <FormControl
                                    className={classes.formControl}
                                    style={{ marginTop: "1.2rem" }}
                                >
                                    <InputLabel id="label-fabricante">Fabricante</InputLabel>
                                    <Select
                                        labelId="label-fabricante"
                                        id="fabNome"
                                        name="fabNome"
                                        value={values.fabNome}
                                        onChange={handleChange}
                                    >
                                        {listFabricante.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.id}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl
                                    className={classes.formControl}
                                    style={{ marginTop: "1.2rem" }}
                                >
                                    <InputLabel id="label-origem">Origem</InputLabel>
                                    <Select
                                        labelId="label-origem"
                                        id="sitOrigem"
                                        name="sitOrigem"
                                        value={values.sitOrigem}
                                        onChange={handleChange}
                                    >
                                        <MenuItem key="C" value="C">
                                            Cliente
                                        </MenuItem>
                                        <MenuItem key="E" value="E">
                                            Ebco
                                        </MenuItem>
                                    </Select>
                                </FormControl>


                                <FormControlLabel
                                    style={{ marginTop: "1.2rem" }}
                                    control={
                                        <Switch
                                            checked={values.sitPrimAnalise}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            name="sitPrimAnalise"
                                            color="primary"
                                        />
                                    }
                                    label="Primeira Analise"
                                />

                                <FormControlLabel
                                    style={{ marginTop: "1.2rem" }}
                                    control={
                                        <Switch
                                            checked={values.sitMonitor}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            name="sitMonitor"
                                            color="primary"
                                        />
                                    }
                                    label="Monitor"
                                />


                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker
                                        value={values.sitDtCadastro}
                                        name="sitDtCadastro"
                                        disabled={true}
                                        format="dd/MM/yyyy-HH:mm:ss"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={classes.nome}
                                        helperText={errors.sitDtCadastro}
                                    />
                                </MuiPickersUtilsProvider>

                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker
                                        value={values.sitDtUltimaOperacao}
                                        name="sitDtUltimaOperacao"
                                        disabled={true}
                                        format="dd/MM/yyyy-HH:mm:ss"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={classes.nome}
                                        helperText={errors.sitDtUltimaOperacao}
                                    />
                                </MuiPickersUtilsProvider>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-end",
                                        marginTop: "2rem",
                                    }}
                                >
                                    <ButtonSave
                                        variant="contained"
                                        size="small"
                                        color="primary"
                                        type="submit"
                                        disabled={!isValid}
                                        style={{
                                            padding: "5px",
                                            color: "white",
                                            fontWeight: "bold",
                                            height: "2rem",
                                            width: "5rem",
                                        }}
                                    >
                                        Gravar
                                    </ButtonSave>
                                    <ButtonDelete
                                        variant="contained"
                                        color="primary"
                                        type="button"
                                        onClick={deleteRecord}
                                        disabled={params.inserir}
                                        style={{
                                            padding: "5px",
                                            color: "white",
                                            fontWeight: "bold",
                                            height: "2rem",
                                            width: "5rem",
                                        }}
                                    >
                                        Excluir
                                    </ButtonDelete>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
}
